// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"173":"bf8d726d","5514":"6b63e2f4"}[chunkId] + ".chunk.css";
};